import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import {
  Box,
  Link,
  Typography
} from '@mui/material';

import {
  footerContentSx,
  footerDividerSx,
  footerLinkSx,
  footerLinksSx,
  footerSx,
  footerTextSx
} from '../../SignIn/SignInStyles';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box component="footer" sx={footerSx}>
      <Box sx={footerContentSx}>
        <Box sx={footerLinksSx}>
          <Typography sx={footerTextSx}>
            © {currentYear} EHRZip. All rights reserved.
          </Typography>

          <Typography component="span" sx={footerDividerSx}>
            |
          </Typography>

          <Link
            component={RouterLink}
            to="#"
            sx={footerLinkSx}>
            Terms & Conditions
          </Link>

          <Typography component="span" sx={footerDividerSx}>
            |
          </Typography>

          <Link
            component={RouterLink}
            to="#"
            sx={footerLinkSx}>
            Privacy Policy
          </Link>
          <Typography component="span" sx={footerDividerSx}>
            |
          </Typography>

          
          <Link
            component={RouterLink}
            to="#"
            sx={footerLinkSx}>
            Cookie Policy
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;